import { render, staticRenderFns } from "./mobile_register_result.vue?vue&type=template&id=0e34f47c&scoped=true&"
import script from "./mobile_register_result.vue?vue&type=script&lang=js&"
export * from "./mobile_register_result.vue?vue&type=script&lang=js&"
import style0 from "./mobile_register_result.vue?vue&type=style&index=0&id=0e34f47c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34f47c",
  null
  
)

export default component.exports